import { Span } from '@codesuma/baseline'
import style from './index.module.css'

// A year in a page title that opens the level above it: the month's year opens
// the year view, the year opens the years view. Both are the same thing, so
// they are the same component.
//
// Underlined rather than boxed or signposted: it is a word in a heading, so it
// wears what a word wears when it opens something. It takes html rather than
// text because a year can carry a dimmed second era (see helpers/year).
//
// Emits 'open'.
export const YearLink = (html: string, label: string) => {
    const base = Span()
    base.addClass(style.base)
    base.attr('role', 'button')
    base.attr('tabindex', '0')
    base.attr('aria-label', label)
    base.html(html)

    base.el.onclick = () => base.emit('open')
    base.el.addEventListener('keydown', (e: KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            base.el.click()
        }
    })

    return base
}
